import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	navAriaLabel: {
		id: 'app.components.tabNavLinks.navAriaLabel',
		defaultMessage: 'page section',
		description: 'Page section navigation aria label',
	},
});
